import { useEffect, useState } from "react";

export const useDelayActionAfterTyping = (action) => {
    const [text, setText] = useState("");

    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if(action) action();
        }, 100);
        return () => clearTimeout(timeOutId);
    // eslint-disable-next-line
    }, [text]);

    return [ text, setText ];
}